import { render, staticRenderFns } from "./TractionChargebackForm.vue?vue&type=template&id=48c1f748&scoped=true&"
import script from "./TractionChargebackForm.vue?vue&type=script&lang=js&"
export * from "./TractionChargebackForm.vue?vue&type=script&lang=js&"
import style0 from "./TractionChargebackForm.vue?vue&type=style&index=0&id=48c1f748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c1f748",
  null
  
)

export default component.exports